import React, { useState } from 'react';
import styles from './DerivedViewsTable.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import Button from 'component/atom/forms/button/Button';
import Modal from 'component/hoc/modal/Modal';
import TableComponent from 'component/molecules/Table/TableComponent';
import ConfirmationModal from 'component/hoc/success-modal/ConfirmationModal';
import { useNavigate } from 'react-router-dom';

const TableRow = ({ data, agentId }) => {
  const navigate = useNavigate();
  const [showResultsModal, setShowResultsModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const tableData = [
    {
      id: 'STU002',
      body: '--',
      url: '--',
      grade: '--',
      score: '--',
      submittedAt: '2023-09-01',
      assignmentId: 'A123',
      attendance: '45%',
      score: '--',
      quiz1: '55',
    },
    {
      id: 'STU003',
      body: '--',
      url: '--',
      grade: '--',
      score: '--',
      submittedAt: '2023-09-01',
      assignmentId: 'A123',
      attendance: '65%',
      score: '--',
      quiz1: '58',
    },
  ];

  return (
    <div className={styles['table-row']}>
      <div className={styles['row-info']}>
        <div className={styles['title-container']}>
          <SvgWithBranding
            type='tableGrid'
            color='#C8C8C8'
            onClick={() => {}}
          />
          <p className={styles['row-title']}>{data?.name}</p>
        </div>
      </div>
      <div className={styles['actions-container']}>
        <Button
          label='View'
          onClick={() => {
            setShowResultsModal(true);
          }}
          type='eye'
          variant='light-rev'
        />
        <Button
          label='Edit'
          onClick={() =>
            navigate(`/bot/update-derived-view/${data?.id}/${agentId}`)
          }
          type='edit'
          variant='primary-rev'
        />
        <Button
          label='Delete'
          onClick={() => {
            setShowConfirmModal(true);
          }}
          type='delete2'
          variant='danger'
        />
      </div>
      <Modal
        title='View Results'
        isOpen={showResultsModal}
        onClose={() => setShowResultsModal(false)}
        exitComponent={
          <Button label='Export CSV' onClick={() => {}} type='download' />
        }
        classname={styles['view-modal']}
      >
        <div className={styles['results-modal-container']}>
          <div className={styles['records-container']}>
            <p>10 flagged records</p>
          </div>
          <TableComponent
            rowKey='text'
            tableContainerClassName={styles['table-container']}
            headerData={{
              tableName: 'Derived Views',
              hasExport: false,
              hasSearch: false,
              hasDelete: false,
              hasEdit: false,
              hasPaging: true,
              hasCheckbox: false,
              hasUploadCSV: false,
              hasFilter: false,
              hasExport: false,
              isExpandable: false,
              fields: [
                { fieldName: 'id', headerName: 'ID' },
                {
                  fieldName: 'body',
                  headerName: 'Body',
                },
                {
                  fieldName: 'url',
                  headerName: 'URL',
                },
                {
                  fieldName: 'grade',
                  headerName: 'Grade',
                },
                {
                  fieldName: 'score',
                  headerName: 'Score',
                },
                {
                  fieldName: 'submittedAt',
                  headerName: 'SubmittedAt',
                },
                {
                  fieldName: 'assignmentId',
                  headerName: 'Assignment ID',
                },
                {
                  fieldName: 'attendance',
                  headerName: 'Attendance',
                },
                {
                  fieldName: 'quiz1',
                  headerName: 'Quiz 1 Score',
                },
              ],
            }}
            externalData={tableData}
          />
        </div>
      </Modal>
      <ConfirmationModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onSubmit={() => {}}
        closeOnSubmit={true}
        onApproveButton={{ text: 'Delete' }}
        text='Delete derived view?'
        subText='This action cannot be undone. This will permanently delete this saved view.'
      />
    </div>
  );
};

export default TableRow;
